import { render, staticRenderFns } from "./PageContentBottom.vue?vue&type=template&id=80dd6362&"
import script from "./PageContentBottom.vue?vue&type=script&lang=ts&"
export * from "./PageContentBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports